module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "ui basic segment"
  }, [_vm._h('div', {
    staticClass: "ui segment"
  }, [_vm._h('form', {
    staticClass: "ui form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.post($event)
      }
    }
  }, [_vm._h('div', {
    staticClass: "field"
  }, [_vm._h('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.input),
      expression: "input",
      modifiers: {
        "trim": true
      }
    }],
    domProps: {
      "value": _vm._s(_vm.input)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input = $event.target.value.trim()
      }
    }
  })]), " ", _vm._h('button', {
    staticClass: "ui blue button",
    class: {
      'loading disabled': _vm.posting
    }
  }, ["Post"])])]), " ", _vm._l((_vm.tweets), function(tweet) {
    return _vm._h('div', {
      staticClass: "ui segment"
    }, [(_vm.findUserPhoto(tweet.owner)) ? _vm._h('img', {
      staticClass: "ui circular image",
      attrs: {
        "src": _vm.findUserPhoto(tweet.owner)
      }
    }) : _vm._e(), "\n    " + _vm._s(_vm.findUserName(tweet.owner)) + " ", _vm._h('br'), "\n    " + _vm._s(tweet.content) + " (" + _vm._s(_vm._f("fromNow")(tweet.timestamp)) + ")\n  "])
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71d46a48!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 243
// module chunks = 2